import { DescriptiveStats, Fixture } from "@tracker-bet-analystic/domain";
import { formatDecimal } from "@tracker-bet-analystic/domain";

interface DescriptiveStatsTableProps {
  stats: Record<string, { home: DescriptiveStats; away: DescriptiveStats }>;
  fixture: Fixture;
}

const metricLabels: Record<string, { label: string; unit: string }> = {
  goalsFor: { label: "Gols a favor", unit: "" },
  goalsAgainst: { label: "Gols contra", unit: "" },
  shots: { label: "Finalizações", unit: "" },
  shotsOnTarget: { label: "Finalizações no alvo", unit: "" },
  corners: { label: "Escanteios", unit: "" },
  yellowCards: { label: "Cartões amarelos", unit: "" },
  redCards: { label: "Cartões vermelhos", unit: "" },
  possession: { label: "Posse de bola", unit: "%" },
  passes: { label: "Passes", unit: "" },
  xGFor: { label: "xG a favor", unit: "" },
  xGAgainst: { label: "xG contra", unit: "" },
};

const metricOrder = [
  "goalsFor",
  "goalsAgainst",
  "shots",
  "shotsOnTarget",
  "corners",
  "yellowCards",
  "redCards",
  "possession",
  "passes",
  "xGFor",
  "xGAgainst",
];

export function DescriptiveStatsTable({ stats, fixture }: DescriptiveStatsTableProps) {
  return (
    <div className="card overflow-hidden">
      <div className="table-container">
        <table className="table" role="table">
          <thead>
            <tr>
              <th scope="col">Métrica</th>
              <th scope="col">{fixture.homeTeamName} (casa)</th>
              <th scope="col">{fixture.awayTeamName} (fora)</th>
            </tr>
          </thead>
          <tbody>
            {metricOrder.map((key) => {
              const meta = metricLabels[key];
              if (!meta) return null;
              const home = stats[key]?.home;
              const away = stats[key]?.away;
              if (!home && !away) return null;

              return (
                <tr key={key}>
                  <td className="font-medium">{meta.label}</td>
                  <td>
                    {home ? (
                      <div className="flex flex-wrap gap-2 text-sm">
                        <span className="font-mono font-medium">{home.mean !== null ? formatDecimal(home.mean) : "—"}</span>
                        <span className="text-[var(--color-text-muted)]">mediana {home.median !== null ? formatDecimal(home.median) : "—"}</span>
                        <span className="text-[var(--color-text-muted)]">n={home.validCount}/{home.selectedCount}</span>
                        <span className="text-[var(--color-text-muted)]">cobertura {(home.coverage ?? 0) * 100}%</span>
                      </div>
                    ) : (
                      <span className="text-[var(--color-text-muted)]">—</span>
                    )}
                  </td>
                  <td>
                    {away ? (
                      <div className="flex flex-wrap gap-2 text-sm">
                        <span className="font-mono font-medium">{away.mean !== null ? formatDecimal(away.mean) : "—"}</span>
                        <span className="text-[var(--color-text-muted)]">mediana {away.median !== null ? formatDecimal(away.median) : "—"}</span>
                        <span className="text-[var(--color-text-muted)]">n={away.validCount}/{away.selectedCount}</span>
                        <span className="text-[var(--color-text-muted)]">cobertura {(away.coverage ?? 0) * 100}%</span>
                      </div>
                    ) : (
                      <span className="text-[var(--color-text-muted)]">—</span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="p-4 text-sm text-[var(--color-text-muted)] border-t border-[var(--color-border)]">
        <p>Valores null indicam ausência de dado (não são zero). Cobertura = válidos / selecionados. Mínimo 8 válidos para elegibilidade.</p>
      </div>
    </div>
  );
}